import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PiecesService } from 'app/services/pieces/pieces.service';
import { ProjetsService } from 'app/services/projets/projets.service';
import { SousBienService } from 'app/services/sousBiens/sous-bien.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { BiensImmobs } from 'app/models/biensImmobs';
import { BiensImmobsBiensImmobs } from 'app/services/biens-immobs/biens-immobs.service';
import { SousBien } from 'app/models/sousBien';

@Component({
  selector: 'app-list-sous-bien',
  templateUrl: './list-sous-bien.component.html',
  styleUrls: ['./list-sous-bien.component.scss']
})
export class ListSousBienComponent implements OnInit {
  idAgency: any;
  Agency: any;
  projects: any[]; // You may replace `any[]` with the actual type of your projects array
  list: any;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['id', 'image', 'projet', 'agence', 'role', 'action'];

  constructor(private SousBienService:SousBienService,private piecesService:PiecesService,private agencieService: AgenciesService, private activatedRoute: ActivatedRoute,private projetService: ProjetsService,private location: Location,private router: Router,private sous:BiensImmobsBiensImmobs) { }

  ngOnInit(): void {
    this.idAgency = this.activatedRoute.snapshot.paramMap.get('id');
    this.agencieService.setIdAgency(this.idAgency);
  
    this.sous.getBiensImmobs(this.idAgency).subscribe(data => {
      this.Agency = data;
      this.list=this.Agency.sous_biens
      console.log(this.Agency.sous_biens      )

      // Sort the projets array by createdAt
      if (this.list) {
        this.list.sort((a, b) => {
          const createdAtA = this.parseDate(a.createdAt);
          const createdAtB = this.parseDate(b.createdAt);
  
          return createdAtA.getTime() - createdAtB.getTime();
        });
      }
  
      // console.log(this.Agency.biens,"here");
    });
  }
  
  // Helper function to parse date string into Date object
  private parseDate(dateString: string): Date {
    const [day, month, year, time] = dateString.split(/\/|\s/);
    const [hour, minute, second] = time.split(':');
  
    // Month is 0-indexed in JavaScript Date, so subtract 1 from the month
    return new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second));
  }
  
  getData() {
    this.agencieService.getAgencieById(this.idAgency).subscribe(data => {
      this.Agency = data;
this.list=this.Agency.biens?.sous_biens
console.log(this.Agency,this.list)
    });
  }

  deleteSousBien(pieceProduit: any) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.SousBienService.deleteSousBien(pieceProduit.id).subscribe((response: any) => {
          console.log(this.dataSource.data);
          // this.AgenciesTunis.splice(i,1)
  
          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Fetch the updated data after deletion
         
        }); setTimeout(() => {
          this.getData()
          }, 500);
        
      }
    });
  }
  navigateBack() {
    this.location.back();
  }
 
}
